import React from 'react';

function Header() {
  return (
    <header className="header">
      <div className="header-copy">
        <h1>Daughters Enterprise</h1>
        <p>Your source for premium Dehydrated powders, Spices and Dry fruits</p>
      </div>
    </header>
  );
}

export default Header;
